<template>
  <div>
    <v-divider />
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="primary"
          outlined
          :to="`/manage/forms/${moderatedOperation.object_type}/${moderatedOperation.form_name}/${moderatedOperation.id}`"
          >{{ $t("button.see.originalForm") }}</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="purple"
          outlined
          v-if="moderatedOperation.object_id"
          :to="`/manage/edit/researchers/edit/${moderatedOperation.object_id}`"
          >{{ $t("button.see.editObject") }}</v-btn
        >
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2" class="d-flex justify-center">
        <FinishFormSwitch :item="moderatedOperation" />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <ProcessingCommentDialog :moderated-operation="moderatedOperation" />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="7" lg="6" v-if="moderatedOperation.data !== undefined">
        <v-alert dense text type="warning" v-if="moderatedOperation.data.user.extend_workplace_assignation_date">
          {{$t('form.info.not_extend_automatic')}}
        </v-alert>
        <v-alert dense text type="success" v-else>
          {{$t('form.info.any_conflict')}}
        </v-alert>
      </v-col>
    </v-row>
    <v-divider />
    <ProcessFormActions :item="moderatedOperation" />
  </div>
</template>

<script>
import ProcessFormActions from "../../action_buttons/ProcessFormActions";
import axios from "axios";
import ProcessingCommentDialog from "../../reusables/ProcessingCommentDialog";
import FinishFormSwitch from "../../reusables/FinishFormSwitch";
export default {
  name: "ProcessAnyConflict",
  components: {
    FinishFormSwitch,
    ProcessingCommentDialog,
    ProcessFormActions
  },

  props: {
    object_type: String
  },

  data: () => ({
    moderatedOperation: {}
  }),

  created() {
    this.getData();
  },
  methods: {
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.object_type +
        "/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.moderatedOperation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
